import { render, staticRenderFns } from "./WaitEditQuestionModal.vue?vue&type=template&id=4dc7dd66&scoped=true&"
import script from "./WaitEditQuestionModal.vue?vue&type=script&lang=js&"
export * from "./WaitEditQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./WaitEditQuestionModal.vue?vue&type=style&index=0&id=4dc7dd66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc7dd66",
  null
  
)

export default component.exports